/**
 * GuidanceBox
 */
import React from 'react';
import { Link as LinkBase } from 'ui-component-library/base';
/** An GuidanceBox for highlighting content. */
var GuidanceBox = function (_a) {
    var text = _a.text, url = _a.url, linkText = _a.linkText, src = _a.src, alt = _a.alt, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? LinkBase : _b;
    var Link = LinkComponent;
    return (React.createElement("div", { "data-cid": "GuidanceBox", className: "block sm:flex p-3 bg-greyLighter" },
        React.createElement("div", { className: "mb-4 sm:mb-0 sm:mr-6" },
            React.createElement("img", { height: "148", width: "240", loading: "lazy", src: src + '?height=148', alt: alt || '', className: "h-37 w-full sm:w-60 sm:min-w-60 mb-0 rounded image__object-fit" })),
        React.createElement("div", { className: "flex flex-col justify-between sm:my-2" },
            text && React.createElement("p", { className: "text-p line-clamp-4" }, text),
            linkText && url && (React.createElement(Link, { to: url, className: "text-teal hover:underline mt-4" }, linkText)))));
};
export default GuidanceBox;
